import { useContext } from 'react'
import { DeviceTypeContext } from '@/context/device-type-context/device-type-context'

export const useDeviceType = () => {
  return useContext(DeviceTypeContext)
}
